import { memo, forwardRef } from 'react';
import { makeStyles } from 'hooks';

const useStyles = makeStyles(theme => ({
  gridOuter: {
    width: '100%'
  },
  gridInner: {
    maxWidth: 1200,
    padding: theme.spacing(0, 1),
    margin: '0 auto'
  }
}));

export default memo(forwardRef(function GridContainer({ children, ...other }, ref) {
  const classes = useStyles();

  return <div ref={ref} className={classes.gridOuter} { ...other }>
    <div className={classes.gridInner}>{children}</div>
  </div>;
}));